'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import {EventManager} from '../util/EventManager.js';
import * as domUtil from '../util/Dom.js';

const threeScripts = {
  GLTFLoader: ['loaders/CustomGLTFLoader.js', 'libs/inflate.min.js', 'loaders/CustomDRACOLoader.js'],
  // GLTFLoader: ['loaders/GLTFLoader.js', 'libs/inflate.min.js', 'loaders/DRACOLoader.js'],
  OBJLoader: ['loaders/OBJLoader.js'],
  FBXLoader: ['loaders/FBXLoader.js'],
  NEXUSLoader: ['nexus/nexus.js', 'nexus/nexus_three.js']
}
const loadedScripts = {};
function loadThreeScript(libPath, name, successCallback, failureCallback){
  const scripts = threeScripts[name];
  if (!scripts) {
    successCallback();
    return;
  }
  const loadTargets = [];
  util.each(scripts, script => {
    if (loadedScripts[script]) {
      return;
    }
    loadTargets.push(libPath + script);
    loadedScripts[script] = true;
  });
  if (loadTargets.length == 0) {
    successCallback();
    return;
  }
  domUtil.loadScripts('text/javascript', loadTargets, successCallback, failureCallback);
}


const ORIGIN_VEC3 = new THREE.Vector3();
const privateMap = util.createPrivateMapper();

const globalCanvas = document.createElement('canvas');
const globalRenderer = new THREE.WebGLRenderer({
  canvas: globalCanvas,
  antialias: true
});
globalRenderer.autoClear = false;

// Overwrite ImageLoader
THREE.ImageLoader = (function(){
  function ImageLoader(manager){
    this.manager = (manager !== undefined) ? manager : THREE.DefaultLoadingManager;
  }
  Object.assign(ImageLoader.prototype, {
    crossOrigin: 'anonymous',
    load: function (url, onLoad, onProgress, onError) {
      if (url === undefined) url = '';
      if (this.path !== undefined) url = this.path + url;

      url = this.manager.resolveURL(url);
      var scope = this;
      var cached = THREE.Cache.get(url);

      if (cached !== undefined) {
        scope.manager.itemStart(url);
        setTimeout(function(){
          if (onLoad) onLoad(cached);
          scope.manager.itemEnd(url);
        }, 0);
        return cached;
      }
  
      var image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');
      const p = {
        url: url,
        responseType: 'blob',
        success: (xhr) => {
          image.src = URL.createObjectURL(xhr.response)
          // if (onLoad) onLoad(image);
          // scope.manager.itemEnd(url)
        },
        failure: (ev) => {
          if (onError) onError(ev)
          scope.manager.itemError(url)
          scope.manager.itemEnd(url)
        },
        progress: (ev) => {
          if (onProgress) {
            onProgress(ev)
          }
        }
      }
  
      function onImageLoad() {
  
        image.removeEventListener('load', onImageLoad, false);
        image.removeEventListener('error', onImageError, false);
  
        THREE.Cache.add(url, this);
  
        if (onLoad) onLoad(this);
        scope.manager.itemEnd(url);
    }
  
      function onImageError(event) {
  
        image.removeEventListener('load', onImageLoad, false);
        image.removeEventListener('error', onImageError, false);
  
        if (onError) onError(event);
  
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      }
  
      image.addEventListener( 'load', onImageLoad, false );
      image.addEventListener( 'error', onImageError, false );
  
      scope.manager.itemStart(url);
      if (url.substr(0, 5) == 'data:' || url.substr(0, 5) == 'blob:') {
        image.src = url
        // setTimeout(function(){
        //   if (onLoad) onLoad(image);
        //   scope.manager.itemEnd(url)
        // })
      } else {
        if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        util.ajax(p);
      }

      // if ( url.substr( 0, 5 ) !== 'data:' ) {
  
      //   if ( this.crossOrigin !== undefined ) image.crossOrigin = this.crossOrigin;
  
      // }
  
      // scope.manager.itemStart( url );
  
      // image.src = url;
  
      return image;
  
    },
  
    setCrossOrigin: function ( value ) {
      this.crossOrigin = value;
      return this;
    },
  
    setPath: function ( value ) {
      this.path = value;
      return this;
    }
  })
  return ImageLoader
})()
// Overwrite Texture Loader
THREE.TextureLoader = (function(){
  function TextureLoader(manager){
    this.manager = (manager !== undefined) ? manager : THREE.DefaultLoadingManager;
  }
  Object.assign( TextureLoader.prototype, {

    crossOrigin: 'anonymous',
  
    load: function (url, onLoad, onProgress, onError) {
  
      var texture = new THREE.Texture();
  
      var loader = new THREE.ImageLoader(this.manager);
      loader.setCrossOrigin(this.crossOrigin);
      loader.setPath(this.path);
  
      loader.load(url, function (image) {
  
        texture.image = image;
  
        // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
        var isJPEG = url.search( /\.jpe?g($|\?)/i ) > 0 || url.search( /^data\:image\/jpeg/ ) === 0;
  
        texture.format = isJPEG ? THREE.RGBFormat : THREE.RGBAFormat;
        texture.needsUpdate = true;
  
        if (onLoad !== undefined) {
          onLoad(texture);
        }
  
      }, onProgress, onError);
  
      return texture;
  
    },
  
    setCrossOrigin: function ( value ) {
  
      this.crossOrigin = value;
      return this;
  
    },
  
    setPath: function ( value ) {
  
      this.path = value;
      return this;
  
    }
  })
  return TextureLoader
})();



const intersectSphere = (function(){
  const v1 = new THREE.Vector3();
  return function(ray, sphere, target1, target2) {
    v1.subVectors(sphere.center, ray.origin);
    const tca = v1.dot(ray.direction);
    const d2 = v1.dot(v1) - tca * tca;
    const radius2 = sphere.radius * sphere.radius;

    if (d2 > radius2) return null;

    const thc = Math.sqrt(radius2 - d2);

    if (thc == 0) return [ray.at(tca, target1)];

    // t0 = first intersect point - entrance on front of sphere
    const t0 = tca - thc;
    // t1 = second intersect point - exit point on back of sphere
    const t1 = tca + thc;

    // test to see if both t0 and t1 are behind the ray - if so, return null
    if (t0 < 0 && t1 < 0) return null;
    // test to see if t0 is behind the ray:
    // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
    // in order to always return an intersect point that is in front of the ray.
    // if (t0 < 0) return [ray.at(t1, target1)];

    // else t0 is in front of the ray, so return the first collision point scaled by t0
    return [ray.at(t0, target1), ray.at(t1, target2)];
  };
})();

const xaxis = new THREE.Vector3();
const yaxis = new THREE.Vector3();
const zaxis = new THREE.Vector3();
const dist = new THREE.Vector3();
const plane = new THREE.Plane();
const vec1 = new THREE.Vector3();
const vec2 = new THREE.Vector3();
const vec3 = new THREE.Vector3();
const vec4 = new THREE.Vector3();
const qt1 = new THREE.Quaternion();
const ray = new THREE.Ray();
const raycaster = new THREE.Raycaster();

function cameraRotateX(camera, cameraTarget, angle){
  dist.copy(camera.position).sub(cameraTarget);
  camera.getWorldDirection(zaxis);
  xaxis.copy(camera.up).applyAxisAngle(zaxis, Math.PI / 2).normalize();
  camera.position.copy(cameraTarget).add(dist.applyAxisAngle(xaxis, angle));
  camera.up.applyAxisAngle(xaxis, angle);
  camera.lookAt(cameraTarget);
}
function cameraRotateY(camera, cameraTarget, angle){
  dist.copy(camera.position).sub(cameraTarget);
  camera.position.copy(cameraTarget).add(dist.applyAxisAngle(camera.up, angle));
  camera.lookAt(cameraTarget);
}
function cameraRotateZ(camera, cameraTarget, angle){
  camera.getWorldDirection(zaxis);
  camera.up.applyAxisAngle(zaxis, angle);
  camera.lookAt(cameraTarget);
}
function cameraPan(camera, cameraTarget, base, to){
  camera.getWorldDirection(zaxis);
  xaxis.copy(camera.up).applyAxisAngle(zaxis, Math.PI / 2).normalize();

  dist.copy(cameraTarget).sub(camera.position);
  plane.setFromNormalAndCoplanarPoint(dist, cameraTarget);

  ray.origin.setFromMatrixPosition(camera.matrixWorld);

  ray.direction.set(base.x, base.y, 0.5).unproject(camera).sub(ray.origin).normalize();
  ray.intersectPlane(plane, vec1);

  ray.direction.set(to.x, to.y, 0.5).unproject(camera).sub(ray.origin).normalize();
  ray.intersectPlane(plane, vec2);

  vec1.sub(vec2);
  cameraTarget.add(vec1);
  camera.position.add(vec1);

  camera.lookAt(cameraTarget);
}

function generateBackground(){
  const material = new THREE.MeshPhysicalMaterial({color: 0xffffff});
  material.metalness = 0;
  material.side = THREE.BackSide;
  // const geometry = new THREE.PlaneGeometry(100, 100);
  const geometry = new THREE.BoxGeometry(1, 1, 1);
  // const geometry = new THREE.SphereGeometry(1, 32, 32);
  const mesh = new THREE.Mesh(geometry, material);
  // mesh.renderOrder = 5;
  return mesh;
};
function generateRaycastPointer(){
  const geometry = new THREE.ConeGeometry(0.2, 1, 32);
  const material = new THREE.MeshStandardMaterial({color: 0xff0000, transparent: true, opacity: 0.7});
  material.depthTest = false;
  const pointMesh = new THREE.Mesh(geometry, material);
  const selectPoint = new THREE.Group();
  selectPoint.add(pointMesh);
  pointMesh.rotateOnAxis(new THREE.Vector3(1, 0, 0), Math.PI);
  pointMesh.position.y = (0.5);
  pointMesh.renderOrder = 1;
  selectPoint.visible = false;
  return selectPoint;
};
function generateRaycastDragPointer(){
  const geometry = new THREE.ConeGeometry(0.1, 1, 32);
  const material = new THREE.MeshStandardMaterial({color: 0x0000ff, transparent: true, opacity: 0.7});
  material.depthTest = false;
  const pointMesh = new THREE.Mesh(geometry, material);
  const selectPoint = new THREE.Group();
  selectPoint.add(pointMesh);
  pointMesh.rotateOnAxis(new THREE.Vector3(1, 0, 0), Math.PI);
  pointMesh.position.y = (0.5);
  pointMesh.renderOrder = 1;
  selectPoint.visible = false;
  return selectPoint;
};
function generateRaycastSphere(){
  const geometry = new THREE.SphereGeometry(1, 16, 16);
  const material = new THREE.MeshBasicMaterial({color: 0xff0000, transparent: true, opacity: 0.2, wireframe: true});
  // material.depthTest = false;
  // const geometry = new THREE.SphereGeometry(1, 32, 32);
  const mesh = new THREE.Mesh(geometry, material);
  mesh.renderOrder = 1;
  return mesh;
}

export class ThreeResource {
  constructor(threeObj3d, params){
    const pv = privateMap(this);
    // this.object = threeObj3d;
    pv.threeObj3d = threeObj3d;
    pv.meshes = [];
    pv.meshes.length = 0;
    pv.boundingBox = new THREE.Box3();
    const box = new THREE.Box3();
    threeObj3d.updateMatrixWorld(true);
    threeObj3d.traverse((obj) => {
      if (obj.isMesh) {
        pv.meshes.push(obj);
        obj.geometry.computeBoundingBox();
        obj.geometry.computeFaceNormals();
        box.copy(obj.geometry.boundingBox.clone());
        obj.updateMatrixWorld(true);
        box.applyMatrix4(obj.matrixWorld);

        pv.boundingBox.expandByPoint(box.min);
        pv.boundingBox.expandByPoint(box.max);
      }
    });
    pv.size = new THREE.Vector3();
    pv.boundingBox.getSize(pv.size);

    pv.centerPosition = new THREE.Vector3();
    pv.boundingBox.getCenter(pv.centerPosition);

    pv.radius = pv.size.distanceTo(ORIGIN_VEC3) / 2;
  }

  get type(){
    return 'three';
  }

  get boundingBox(){
    return privateMap(this).boundingBox;
  }

  get meshes(){
    return privateMap(this).meshes;
  }

  get size(){
    return privateMap(this).size;
  }

  get centerPosition(){
    return privateMap(this).centerPosition;
  }

  get radius(){
    return privateMap(this).radius;
  }

  rotateY(angle){
    const pv = privateMap(this);
    pv.threeObj3d.translateX(pv.centerPosition.x);
    pv.threeObj3d.translateY(pv.centerPosition.y);
    pv.threeObj3d.translateZ(pv.centerPosition.z);
    pv.threeObj3d.rotateY(angle);
    pv.threeObj3d.translateX(-pv.centerPosition.x);
    pv.threeObj3d.translateY(-pv.centerPosition.y);
    pv.threeObj3d.translateZ(-pv.centerPosition.z);
  }

  addToScene(scene){
    const pv = privateMap(this);
    scene.add(pv.threeObj3d);
  }
}

export class ThreeDisposition {
  constructor(){
    const pv = privateMap(this);
    pv.background = generateBackground();

    pv.camera = new THREE.PerspectiveCamera(40);
    pv.cameraTarget = new THREE.Vector3();

    pv.ambientLight = new THREE.AmbientLight(0xffffff, 0.1);

    // pv.cameraLight = new THREE.DirectionalLight(0xffffff, 2);
    pv.cameraLight = new THREE.PointLight(0xffffff, 2);
    // pv.cameraLight = new THREE.SpotLight(0xffffff, 2);

    pv.helperCameraLight = new THREE.DirectionalLight(0xffffff, 2);

    pv.raycastSphere = generateRaycastSphere();
    pv.raycastSphere.visible = false;

    pv.raycastPointer = generateRaycastPointer();
    pv.raycastPointer.visible = false;

    pv.raycastDragPointer = generateRaycastDragPointer();
    pv.raycastDragPointer.visible = false;

    this.cameraLightDistance = 1;
  }

  get camera(){
    return privateMap(this).camera;
  }

  get cameraTarget(){
    return privateMap(this).cameraTarget;
  }

  get ambientLight() {
    return privateMap(this).ambientLight;
  }

  get cameraLight(){
    return privateMap(this).cameraLight;
  }

  get background(){
    return privateMap(this).background;
  }

  get helperCameraLight(){
    return privateMap(this).helperCameraLight;
  }

  get raycastSphere(){
    return privateMap(this).raycastSphere;
  }

  get raycastPointer(){
    return privateMap(this).raycastPointer;
  }

  get raycastDragPointer(){
    return privateMap(this).raycastDragPointer;
  }

  addToScene(scene, helperScene){
    const pv = privateMap(this);
    scene.background = new THREE.Color(0xffffff);
    scene.add(pv.background);
    scene.add(pv.ambientLight);
    scene.add(pv.cameraLight);

    helperScene.add(pv.helperCameraLight);
    helperScene.add(pv.raycastSphere);
    helperScene.add(pv.raycastPointer);
    helperScene.add(pv.raycastDragPointer);
  }

  update(){
    const pv = privateMap(this);
    const cameraLight = pv.cameraLight;
    const helperCameraLight = pv.helperCameraLight;
    const camera = pv.camera;
    const cameraTarget = pv.cameraTarget;
    const cameraLightDistance = this.cameraLightDistance;

    camera.getWorldDirection(vec1);
    vec1.negate();
    // vec1.copy(pv.cameraDirection).negate();
    vec1.setLength(cameraLightDistance);
    
    cameraLight.position.copy(cameraTarget).add(vec1);
    cameraLight.up.copy(camera.up);
    cameraLight.lookAt(pv.cameraTarget);

    helperCameraLight.position.copy(cameraLight.position);
    helperCameraLight.quaternion.copy(cameraLight.quaternion);
  }
}

export class ThreeContentControl extends EventManager{
  constructor(){
    super();
    const pv = privateMap(this);
    pv.disposition = new ThreeDisposition();

    pv.canvasSize = {x:0, y:0}
    pv.size = new THREE.Vector3();
    pv.boundingBox = new THREE.Box3();
    pv.centerPosition = new THREE.Vector3();
    pv.zoom = 1;
    pv.radius = 0;
    pv.minDistance = 0.1;
    pv.maxDistance = 1;
    pv.raycastDragBasePoint = new THREE.Vector3();
  }

  get disposition(){
    return privateMap(this).disposition;
  }

  set resource(resource) {
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const raycastSphere = pv.disposition.raycastSphere;
    const raycastPointer = pv.disposition.raycastPointer;
    const raycastDragPointer = pv.disposition.raycastDragPointer;
    const background = pv.disposition.background;

    pv.resource = resource;
    if (!pv.resource) {
      return;
    }
    pv.size.copy(resource.size);
    pv.boundingBox.copy(resource.boundingBox);
    pv.centerPosition.copy(resource.centerPosition);

    const size = resource.size;
    camera.near = Math.min(size.x, size.y, size.z) * 0.01;
    camera.far = Math.max(size.x, size.y, size.z) * 10;
    camera.updateProjectionMatrix();
    this.calculateDistanceMinMax()
    raycastSphere.position.copy(resource.centerPosition);
    // raycastSphere.scale.set(resource.radius, resource.radius, resource.radius);
  
    const pointerScale = resource.radius / 10;
    raycastPointer.scale.set(pointerScale, pointerScale, pointerScale);
  
    const dragPointerScale = resource.radius / 10;
    raycastDragPointer.scale.set(dragPointerScale, dragPointerScale, dragPointerScale);

    background.scale.setLength(resource.radius * 4);
    background.position.copy(resource.centerPosition);
  }

  calculateDistanceMinMax(){
    const pv = privateMap(this);
    if (!pv.resource) {
      return;
    }
    const size = pv.size;
    const camera = pv.disposition.camera;

    const vFov = camera.fov * (Math.PI / 180);
    const hFov = 2 * Math.atan(Math.tan(vFov / 2) * camera.aspect);

    const diag = size.distanceTo(ORIGIN_VEC3);
    const rad = diag / 2;
    const calc = function(sz, fov){
      return (sz / 2) / Math.tan(fov / 2) + rad;
    };
    const maxL = Math.max(size.x, size.y, size.z);
    const dist = Math.max(calc(maxL, vFov), calc(maxL, hFov));
    pv.minDistance = rad / 100;
    pv.maxDistance = dist;
    pv.disposition.cameraLightDistance = pv.maxDistance;
  }

  set viewSize(size){
    const pv = privateMap(this);
    if (!(size.x > 0 && size.y > 0)) {
      return
    }
    if (pv.canvasSize.x == size.x && pv.canvasSize.y == size.y) {
      return
    }
    pv.canvasSize.x = size.x
    pv.canvasSize.y = size.y
    pv.disposition.camera.aspect = size.x / size.y;
    pv.disposition.camera.updateProjectionMatrix();
    this.calculateDistanceMinMax()
    this.zoom = pv.zoom
  }

  get zoom(){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    vec1.copy(camera.position).sub(cameraTarget);
    return vec1.length() / pv.maxDistance;
  }
  set zoom(z){
    const nz = Math.min(1, Math.max(0, z));
    const pv = privateMap(this);
    pv.zoom = nz;
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    camera.getWorldDirection(vec1);
    vec1.negate();
    vec1.setLength(pv.minDistance + (pv.maxDistance - pv.minDistance) * nz);
    camera.position.copy(cameraTarget).add(vec1);
    camera.lookAt(cameraTarget);
  }

  pan(base, to){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    cameraPan(camera, cameraTarget, base, to);
    // camera.getWorldDirection(pv.cameraDirection);
  }
  
  objectRotateY(angle){
    const pv = privateMap(this);
    if (!pv.resource) {
      return;
    }
    pv.resource.rotateY(angle);
  }

  rotateX(angle){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    cameraRotateX(camera, cameraTarget, angle);
    // camera.getWorldDirection(pv.cameraDirection);
  }
  rotateY(angle){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    cameraRotateY(camera, cameraTarget, angle);
    // camera.getWorldDirection(pv.cameraDirection);
  }
  rotateZ(angle){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    cameraRotateZ(camera, cameraTarget, angle);
    // camera.getWorldDirection(pv.cameraDirection);
  }

  homeView(){
    const pv = privateMap(this);
    const size = pv.size;
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    const center = pv.centerPosition;

    pv.boundingBox.getCenter(center);
    cameraTarget.copy(pv.centerPosition);

    const vFov = camera.fov * (Math.PI / 180);
    const hFov = 2 * Math.atan(Math.tan(vFov / 2) * camera.aspect);

    const rad = size.distanceTo(ORIGIN_VEC3) / 2;
    const calc = function(sz, fov){
      // return (sz / 2) / Math.tan(fov / 2) + rad;
      return (sz / 2) / Math.tan(fov / 2) + (size.z / 2);
    };
    const dist = Math.max(calc(size.y, vFov), calc(size.x, hFov));

    camera.position.set(center.x, center.y, center.z + dist);
    camera.up.set(0, 1, 0);
    camera.lookAt(cameraTarget);
    // camera.getWorldDirection(pv.cameraDirection);
  };

  startRaycastDrag(viewPoint){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;

    ray.origin.setFromMatrixPosition(camera.matrixWorld);
    ray.direction.set(viewPoint.x, viewPoint.y, 0.5).unproject(camera).sub(ray.origin).normalize();

    raycaster.setFromCamera(viewPoint, camera);
    const intersects = raycaster.intersectObjects(pv.resource.meshes);
    let intersect;
    let point;

    if (intersects && intersects.length > 0) {
      intersect = intersects[0];
      point = intersect.point;
    }
    if (!point) {
      // background intersection
      const backgroundIntersects = raycaster.intersectObject(pv.disposition.background);
      if (backgroundIntersects && backgroundIntersects.length > 0) {
        point = backgroundIntersects[0].point;
      } else {
        // camera sphere intersection
        vec1.copy(cameraTarget).sub(camera.position).normalize();
        // vec1.copy(pv.camera.position).sub(pv.cameraTarget).normalize();
        // const sphere = new THREE.Sphere(pv.cameraTarget, vec1.length());
        // const vecs = intersectSphere(ray, sphere, vec2, vec3);
        // console.log(vecs);
        // if (vecs){
        //   point = vecs[vecs.length - 1];
        // }
        // point = ray.intersectSphere(sphere, vec2);
        if (!point) {
          // plane intersection
          const plane = new THREE.Plane();

          plane.setFromNormalAndCoplanarPoint(vec1, cameraTarget);
          point = ray.intersectPlane(plane, vec2);
        } else {
          console.log('camera sphere intersection');
        }
      }
    }
    if (!point) {
      return;
    }

    const raycastDragPointer = pv.disposition.raycastDragPointer;
    const raycastSphere = pv.disposition.raycastSphere;
    const raycastPointer = pv.disposition.raycastPointer;

    raycastDragPointer.position.copy(point)
    dist.copy(point).sub(cameraTarget);
    pv.raycastDragBasePoint.copy(dist);
    const radius = dist.length();

    pv.raycastSphereGeometry = new THREE.Sphere(cameraTarget, radius);
    raycastSphere.position.copy(cameraTarget);
    raycastSphere.scale.set(radius, radius, radius);

    vec1.set(0, 1, 0);
    vec2.copy(dist).normalize();
    raycastDragPointer.quaternion.setFromUnitVectors(vec1, vec2);

    const vecs = intersectSphere(ray, pv.raycastSphereGeometry, vec1, vec2);
    pv.raycastDragSide = 0;
    if (vecs && vecs.length > 1) {
      const d1 = vec1.subVectors(raycastDragPointer.position, vecs[0]).length();
      const d2 = vec1.subVectors(raycastDragPointer.position, vecs[1]).length();
      if (d1 > d2) {
        pv.raycastDragSide = 1;
      }
    }

    raycastSphere.material.color.set(pv.raycastDragSide == 0 ? 0xffff00 : 0xff00ff);
    // raycastSphere.material.side = pv.raycastDragSide == 0 ? THREE.FrontSide : THREE.BackSide;

    if (intersect && intersect.face) {
      raycastPointer.position.copy(raycastDragPointer.position);

      vec1.copy(intersect.face.normal);
      vec1.applyMatrix4(intersect.object.matrixWorld);
      vec1.normalize();

      vec2.set(0, 1, 0);
      const qt1 = new THREE.Quaternion();
      qt1.setFromUnitVectors(vec2, vec1);

      raycastPointer.quaternion.copy(qt1);
      raycastPointer.visible = true;
    }

    pv.raycastDragOut = false;
    raycastSphere.visible = true;
    raycastDragPointer.visible = true;
  }
  moveRaycastDrag(viewPoint){
    const pv = privateMap(this);
    const camera = pv.disposition.camera;
    const cameraTarget = pv.disposition.cameraTarget;
    const raycastSphere = pv.disposition.raycastSphere;

    // raycaster.setFromCamera(viewPoint, pv.camera);
    ray.origin.setFromMatrixPosition(camera.matrixWorld);
    ray.direction.set(viewPoint.x, viewPoint.y, 0.5).unproject(camera).sub(ray.origin).normalize();
    let vecs = intersectSphere(ray, pv.raycastSphereGeometry, vec1, vec2);
    if (!vecs) {
      if (!pv.raycastDragOut) {
        pv.raycastDragOut = true;
        pv.raycastDragSide = pv.raycastDragSide == 1 ? 0 : 1;
        raycastSphere.material.color.set(pv.raycastDragSide == 0 ? 0xffff00 : 0xff00ff);
        // raycastSphere.material.side = pv.raycastDragSide == 0 ? THREE.FrontSide : THREE.BackSide;
      }
      return;
    }
    pv.raycastDragOut = false;
    vec3.copy(vecs[vecs.length > 1 ? pv.raycastDragSide : 0]);
    vec3.sub(cameraTarget);

    vec1.copy(vec3).normalize();
    vec2.copy(pv.raycastDragBasePoint).normalize();
    qt1.setFromUnitVectors(vec1, vec2);

    vec1.copy(camera.position).sub(cameraTarget).applyQuaternion(qt1);

    camera.position.copy(cameraTarget).add(vec1);
    camera.up.applyQuaternion(qt1);
    camera.lookAt(cameraTarget);
    // camera.getWorldDirection(pv.cameraDirection);
  }
  endRaycastDrag(){
    const pv = privateMap(this);
    pv.disposition.raycastSphere.visible = false;
    pv.disposition.raycastDragPointer.visible = false;
  }
}

export class ThreeRenderer {
  constructor(){
  }
  render(view, resource, control, session){
    const pv = privateMap(this);
    const disposition = control.three.disposition;
    if (!session.three) {
      session.three = {
        mainScene: new THREE.Scene(),
        helperScene: new THREE.Scene()
      }
      resource.addToScene(session.three.mainScene);
      disposition.addToScene(session.three.mainScene, session.three.helperScene);
    }
    disposition.update();

    globalRenderer.setSize(view.size.x, view.size.y);
    globalRenderer.clear(true, true, true);
    globalRenderer.render(session.three.mainScene, disposition.camera);
    globalRenderer.render(session.three.helperScene, disposition.camera);

    view.context2d.drawImage(globalCanvas, 0, 0);
    // globalRenderer.render(helperScene, camera);
    if (control.three.animation) {
      if (control.three.animation.process((new Date()).getTime())) {
        view.requestRender();
      }
    }
  }
}

class GLTFLoader {
  constructor(options){
    this.loadingManager = options.loadingManager;
    this.loader = new THREE.GLTFLoader(options.loadingManager);
    THREE.DRACOLoader.setDecoderPath(options.libPath + options.dracoLibPath);
    // THREE.DRACOLoader.setDecoderConfig({type: 'js'});
    THREE.DRACOLoader.getDecoderModule();
    const dracoLoader = new THREE.DRACOLoader();
    // dracoLoader.verbosity = 1
    this.loader.setDRACOLoader(dracoLoader);
  }
  load(url, successCallback, params) {
    const loadObj = this.loader.load(url, (gltf) => {
      // success
      if (this.loadingManager.aborted) {
        return;
      }
      successCallback(new ThreeResource(gltf.scene, {animations: gltf.animations}));
    }, (ev) => {
      // progress
      if (this.loadingManager.aborted) {
        return;
      }
      if (params.progress) {
        params.progress(ev, url);
      }
    }, (ev) => {
      // error
      if (this.loadingManager.aborted) {
        return;
      }
      this.loadingListener = null;
      if (params.failure) {
        params.failure(ev);
      }
    });
    return loadObj;
  }
}

class THREEJSONLoader {
  constructor(options){
    this.loadingManager = options.loadingManager;
    const Loader = function(manager){
      THREE.ObjectLoader.call(this, manager);
    }
    Loader.prototype = Object.assign(THREE.ObjectLoader.prototype, {
      parseImages: function(json, onLoad) {
        var scope = this;
        var images = {};
        if ( json !== undefined && json.length > 0 ) {
          var manager = new THREE.LoadingManager(onLoad);
          var loader = new THREE.ImageLoader(manager);
          loader.setCrossOrigin( this.crossOrigin );

          function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function(){
              scope.manager.itemEnd(url);
            }, function(xhr){
              if (scope.manager.onFileProgress) {
                scope.manager.onFileProgress(url, xhr);
              }
            }, function(){
              scope.manager.itemError(url);
              scope.manager.itemEnd(url);
            });
          }
      
          for (var i = 0, il = json.length; i < il; i ++){
    
            var image = json[i];
            var url = image.url;
    
            if (Array.isArray(url)) {
              // load array of images e.g CubeTexture
              images[image.uuid] = [];
              for (var j = 0, jl = url.length; j < jl; j ++){
                var currentUrl = url[j];
                var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(currentUrl) ? currentUrl : scope.texturePath + currentUrl;
                images[image.uuid].push( loadImage( path ) );
              }
            } else {
              // load single image
              var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(image.url) ? image.url : scope.texturePath + image.url;
    
              images[image.uuid] = loadImage(path);
            }
          }
        }
        return images;
      }
    
    });
    this.loader = new Loader(options.loadingManager);
    this.loader.crossOrigin = 'anonymous';
  }
  load(url, successCallback, params) {
    const loadObj = this.loader.load(url, (obj) => {
      // success
      if (this.loadingManager.aborted) {
        return;
      }
      successCallback(new ThreeResource(obj));
    }, (ev) => {
      // progress
      if (this.loadingManager.aborted) {
        return;
      }
      if (params.progress) {
        params.progress(ev);
      }
    }, (ev) => {
      // error
      if (this.loadingManager.aborted) {
        return;
      }
      if (params.failure) {
        params.failure(ev);
      }
    });
    return loadObj;
  }
}

class OBJLoader {
  constructor(options){
    this.loadingManager = options.loadingManager;
    this.loader = new THREE.OBJLoader(options.loadingManager);
    this.loader.crossOrigin = 'anonymous';
  }
  load(url, successCallback, params) {
    const loadObj = this.loader.load(url, (obj) => {
      // success
      if (this.loadingManager.aborted) {
        return;
      }
      successCallback(new ThreeResource(obj));
    }, (ev) => {
      // progress
      if (this.loadingManager.aborted) {
        return;
      }
      if (params.progress) {
        params.progress(ev);
      }
    }, (ev) => {
      // error
      if (this.loadingManager.aborted) {
        return;
      }
      if (params.failure) {
        params.failure(ev);
      }
    });
    return loadObj;
  }
}

function getLoader(options, loaderType, successCallback, failureCallback){
  loadThreeScript(options.libPath, loaderType.name, () => {
    const loader = new loaderType.Type(options);
    successCallback(loader);
  }, failureCallback);
}
export class ThreeResourceLoader {
  constructor(options){
    this.loadingListener = null;
    // this.options = options ? options : {};
    this.options = Object.assign({
      dracoLibPath : 'libs/draco/gltf/'
    }, options);
  
    this.loaderTypeResolver = options.loaderTypeResolver ? options.loaderTypeResolver : (source) => {
      // console.log(params);
      if (source.format == 'model/gltf+json' || source.id.match(/\.gltf$/)) {
        // GLTF
        return {
          loaderType: {
            name: 'GLTFLoader',
            Type: GLTFLoader
          },
          url: source.id
        }
      } else if (source.format == 'application/vnd.threejs+json') {
        return {
          loaderType: {
            name: 'THREEJSONLoader',
            Type: THREEJSONLoader
          },
          url: source.id
        }
      } else if (source.format == 'application/wavefront-obj') {
        return {
          loaderType: {
            name: 'OBJLoader',
            Type: OBJLoader
          },
          url: source.id
        }
      }
    }
  }

  load(source, successCallback, params){
    const p = this.loaderTypeResolver(source);
    if (!p) {
      throw new Error('unknown loader. id:' + source.id + ' format:' + source.format);
    }
    const paramsWrapper = Object.assign({}, params);
    if (paramsWrapper.always) {
      util.each(['failure', 'abort'], (fn) => {
        paramsWrapper[fn] = (ev) => {
          if (params[fn]) {
            params[fn](ev);
          }
          paramsWrapper.always();
        }
      });
    }

    this.loadingListener = {
      onStart: function(url, itemsLoaded, itemsTotal){
        if (params.itemStart) {
          params.itemStart(url, itemsLoaded, itemsTotal);
        }
      },
      onProgress: function(url, itemsLoaded, itemsTotal){
        if (params.itemProgress) {
          params.itemProgress(url, itemsLoaded, itemsTotal);
        }
      },
      onFileProgress: function(url, xhr){
        if (params.progress) {
          params.progress(xhr, url);
        }
      }
    }

    const loadingManager = new THREE.LoadingManager();
    // loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
    //   console.log('onStart', itemsLoaded, itemsTotal)
    //   if (this.loadingListener) {
    //     this.loadingListener.onStart(url, itemsLoaded, itemsTotal)
    //   }
    // };
    // loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
    //   // console.log('onProgress', itemsLoaded, itemsTotal)
    //   if (this.loadingListener) {
    //     this.loadingListener.onProgress(url, itemsLoaded, itemsTotal)
    //   }
    // };
    loadingManager.onFileProgress = (url, xhr) => {
      if (!loadingManager.aborted) {
        if (params.progress) {
          params.progress(xhr, url);
        }
      }
    }
    const is = loadingManager.itemStart
    loadingManager.itemStart = (url) => {
      if (!loadingManager.aborted) {
        if (params.itemStart) {
          params.itemStart(url);
        }
      }
      is(url)
    }
    const ie = loadingManager.itemStart
    loadingManager.itemEnd = (url) => {
      if (!loadingManager.aborted) {
        if (params.itemProgress) {
          params.itemProgress(url);
        }
      }
      ie(url)
    }
    loadingManager.aborted = false;

    const asyncControl = {
      abort: function(){
        if (this.target && this.target.abort) {
          this.target.abort();
        }
        loadingManager.aborted = true;
      }
    }

    getLoader({
      ...this.options,
      loadingManager: loadingManager
    }, p.loaderType, (loader) => {
      asyncControl.target = loader.load(p.url, (resource) => {
        // this.loadingListener = null;
        successCallback(resource);
        if (paramsWrapper.always) {
          paramsWrapper.always();
        }
      }, paramsWrapper);

    });
    return asyncControl;
  }
}
